/**
 * AVA-787: the Tag Harvester page only unharvests, in its own facility. A master is deleted only from
 * Masters Management, once it is harvested nowhere. These helpers keep the wording the same on every
 * harvester screen.
 */

export const HARVEST_KEPT_NOTE =
  'The tags stay in Masters and keep their data in the other facilities. You can harvest them again.';

export function facilityLabel(store, facilityId) {
  // The id → name dictionary is loaded only by some screens; the open facility is always known.
  const current = store.getters['FACILITY/GET_FACILITY'];
  return store.getters.getFacilityDict?.[facilityId]
    || (current?.id === facilityId ? current.name : null)
    || 'this facility';
}

export function tagCountLabel(count) {
  return `${count} tag${count === 1 ? '' : 's'}`;
}

/**
 * Tells the user what the server did. `skipped` tags have old model links that can't be tied to this
 * facility safely; the tag card refuses them too.
 */
export function notifyUnharvestResult(notify, label, facility, { unharvested = 0, skipped = 0 } = {}) {
  const options = { position: 'top-right', timeout: skipped ? 9000 : 4000 };
  if (!skipped) {
    notify.success(`${label}: ${tagCountLabel(unharvested)} unharvested from ${facility}.`, options);
    return;
  }
  notify.warning(
    `${label}: ${unharvested} unharvested from ${facility}. ${skipped} skipped: their old model links `
      + `can't be tied to ${facility} safely. Open them from the tag card to fix.`,
    options,
  );
}
